import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import { getInputDeliveryById } from "../../api/web";
import moment from "moment";

const InputDeliveryDetail = (props) => {

    const id = props.match.params.id;
    const [initialLoading, setInitialLoading] = useState(true);
    const [delivery, setDelivery] = useState(null);

    useEffect(() => {
        getInputDeliveryById(id).then((response) => {
            if (!response.error) {
                setDelivery(response.payload);
            }
            setInitialLoading(false);
        });
    }, [id]);

    const deliveryStatusBadge = (status) => {
        const map = {
            pending: { cls: 'text-white', style: { backgroundColor: '#fd7e14' } },
            processed: { cls: 'bg-info text-white', style: {} },
            dispatched: { cls: 'bg-primary text-white', style: {} },
            received: { cls: 'bg-success text-white', style: {} }
        };
        const c = map[status] || { cls: '', style: {} };
        return <span className={`badge ${c.cls}`} style={c.style}>{status || '—'}</span>;
    };

    const farmerReceiptBadge = (status) => {
        const map = {
            pending: { cls: 'text-white', style: { backgroundColor: '#fd7e14' } },
            received: { cls: 'bg-success text-white', style: {} }
        };
        const c = map[status] || { cls: '', style: {} };
        return <span className={`badge ${c.cls}`} style={c.style}>{status || '—'}</span>;
    };

    if (initialLoading) {
        return (
            <div className="content-body">
                <div className="container d-flex justify-content-center ht-100p">
                    <div className="d-flex flex-column align-items-center justify-content-center">
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        <p className="mg-t-10">Loading input delivery</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!delivery) {
        return (
            <div className="content-body">
                <div className="container pd-x-0">
                    <div className="mg-b-20">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/dashboard">Menu</Link></li>
                                <li className="breadcrumb-item"><Link to="/input_delivery">Input Deliveries</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Not found</li>
                            </ol>
                        </nav>
                        <p className="tx-danger">Input delivery not found.</p>
                        <Link to="/input_delivery" className="btn btn-sm btn-primary">Back to Input Deliveries</Link>
                    </div>
                </div>
            </div>
        );
    }

    const farmerName = delivery.farmer
        ? `${delivery.farmer.first_name || ''} ${delivery.farmer.last_name || ''}`.trim() || '—'
        : '—';
    const agentName = delivery.agent
        ? `${delivery.agent.first_name || ''} ${delivery.agent.last_name || ''}`.trim() || '—'
        : '—';
    const schemeName = delivery.scheme?.scheme_name ?? '—';
    const inputs = delivery.input || [];
    const actualInputs = delivery.actual_input || [];

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/dashboard">Menu</Link></li>
                                <li className="breadcrumb-item"><Link to="/input_delivery">Input Deliveries</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Input Delivery #{delivery.id}</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-5 tx-spacing--1">Input Delivery #{delivery.id}</h4>
                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <span className="tx-color-03 tx-13">{farmerName} · {schemeName}</span>
                            {deliveryStatusBadge(delivery.delivery_status)}
                            {farmerReceiptBadge(delivery.farmer_receipt_status)}
                        </div>
                    </div>
                    <div className="d-none d-md-block">
                        <Link to="/input_delivery" className="btn btn-sm pd-x-15 btn-secondary btn-uppercase">
                            <i className="wd-10 mg-r-5 fa fa-arrow-left"></i> Back to list
                        </Link>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="nav-wrapper mg-b-20 tx-13">
                            <ul className="nav nav-line nav-fill tx-medium">
                                <li className="nav-item">
                                    <a href="#info" className="nav-link active" data-bs-toggle="tab">
                                        <i className="ion-md-information-circle"/> Information
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="#planned" className="nav-link" data-bs-toggle="tab">
                                        <i className="ion-md-list"/> Planned Inputs ({inputs.length})
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="#actual" className="nav-link" data-bs-toggle="tab">
                                        <i className="ion-md-cube"/> Actual Inputs ({actualInputs.length})
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="tab-content">
                            <div id="info" className="tab-pane fade active show">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row row-sm">
                                            <div className="col-md-6">
                                                <p><strong>Farmer:</strong> {farmerName}</p>
                                                <p><strong>Agent:</strong> {agentName}</p>
                                                <p><strong>Scheme:</strong> {schemeName}</p>
                                                <p><strong>Delivery status:</strong> {deliveryStatusBadge(delivery.delivery_status)}</p>
                                                <p><strong>Farmer receipt:</strong> {farmerReceiptBadge(delivery.farmer_receipt_status)}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <p><strong>Quantity:</strong> {delivery.quantity != null ? delivery.quantity : '—'}</p>
                                                <p><strong>Delivery success:</strong> {delivery.delivery_success != null ? (delivery.delivery_success ? 'Yes' : 'No') : '—'}</p>
                                                <p><strong>Agent confirmed:</strong> {delivery.is_agent_confirmed != null ? (delivery.is_agent_confirmed ? 'Yes' : 'No') : '—'}</p>
                                                <p><strong>Farmer confirmed:</strong> {delivery.is_farmer_confirmed != null ? (delivery.is_farmer_confirmed ? 'Yes' : 'No') : '—'}</p>
                                                <p><strong>Date created:</strong> {delivery.date_created ? moment(delivery.date_created).format("Do MMM, YYYY HH:mm") : '—'}</p>
                                                <p><strong>Date modified:</strong> {delivery.date_modified ? moment(delivery.date_modified).format("Do MMM, YYYY HH:mm") : '—'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div id="planned" className="tab-pane fade">
                                <div className="card">
                                    <div className="card-header">
                                        <h6 className="mg-b-0">Planned Inputs</h6>
                                    </div>
                                    <div className="card-body">
                                        {inputs.length === 0 ? (
                                            <p className="tx-color-03 mg-b-0">No planned inputs.</p>
                                        ) : (
                                            <div className="table-responsive">
                                                <table className="table table-bordered table-sm">
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th>Type</th>
                                                            <th>Quantity / Unit</th>
                                                            <th>Price</th>
                                                            <th>Currency</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {inputs.map((item, idx) => (
                                                            <tr key={idx}>
                                                                <td>{item.name ?? item.input_name ?? '—'}</td>
                                                                <td>{item.input_type ?? '—'}</td>
                                                                <td>{item.unit != null ? item.unit : '—'}</td>
                                                                <td>{item.price != null ? item.price : '—'}</td>
                                                                <td>{item.currency ?? '—'}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div id="actual" className="tab-pane fade">
                                <div className="card">
                                    <div className="card-header">
                                        <h6 className="mg-b-0">Actual Inputs Delivered</h6>
                                    </div>
                                    <div className="card-body">
                                        {actualInputs.length === 0 ? (
                                            <p className="tx-color-03 mg-b-0">No actual inputs recorded.</p>
                                        ) : (
                                            <div className="table-responsive">
                                                <table className="table table-bordered table-sm">
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th>Type</th>
                                                            <th>Quantity / Unit</th>
                                                            <th>Price</th>
                                                            <th>Currency</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {actualInputs.map((item, idx) => (
                                                            <tr key={idx}>
                                                                <td>{item.name ?? item.input_name ?? '—'}</td>
                                                                <td>{item.input_type ?? '—'}</td>
                                                                <td>{item.unit != null ? item.unit : '—'}</td>
                                                                <td>{item.price != null ? item.price : '—'}</td>
                                                                <td>{item.currency ?? '—'}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InputDeliveryDetail;
